import { DispatchDifficultyLevel, EquipmentRarity } from "@/enums/mission";
import {
  MateDispatch,
  MateDispatchMember,
  MateEquipment,
} from "@/types/entity";

// 任务成功概率相关

const levelMap: Record<DispatchDifficultyLevel, number> = {
  [DispatchDifficultyLevel.Easy]: 0.85,
  [DispatchDifficultyLevel.Medium]: 0.75,
  [DispatchDifficultyLevel.Hard]: 0.35,
  [DispatchDifficultyLevel.Nightmare]: 0.1,
  [DispatchDifficultyLevel.Hell]: 0.01,
};

export const levelBaseRate = (difficultyLevel: DispatchDifficultyLevel) => {
  if (!difficultyLevel) return 0;
  return levelMap[difficultyLevel];
};

export const rarityMap: Record<EquipmentRarity, number> = {
  [EquipmentRarity.Common]: 0.01,
  [EquipmentRarity.Rare]: 0.02,
  [EquipmentRarity.Epic]: 0.03,
};

export const getEquipmentExtraRate = (carriedEquipmentzz: MateEquipment[]) => {
  if (!carriedEquipmentzz?.length) return 0;
  return carriedEquipmentzz.reduce((acc, v) => acc + rarityMap[v.rarity], 0);
};

export const getUserCount = (
  dispatchMemberzz: MateDispatchMember[] | undefined
) => {
  if (!dispatchMemberzz?.length) return 0;
  const userMap = new Set<number>();
  dispatchMemberzz?.forEach((v) => {
    if (v.mate?.userId) {
      userMap.add(v.mate.userId);
    }
  });
  return userMap.size - 1;
};

export const getUserExtraRate = (dispatchMemberzz: MateDispatchMember[]) => {
  return getUserCount(dispatchMemberzz) * 0.05;
};

export const getPreviousMissionCount = (dispatchMission: MateDispatch) => {
  const { carriedJournalzz, carriedDispatchzz, carriedMailzz } =
    dispatchMission;
  let count = 0;
  if (carriedJournalzz?.length) count += carriedJournalzz.length;
  if (carriedDispatchzz?.length) count += carriedDispatchzz.length;
  if (carriedMailzz?.length) count += carriedMailzz.length;
  return count;
};

export const getPreviousMissionExtraRate = (dispatchMission: MateDispatch) => {
  return getPreviousMissionCount(dispatchMission) * 0.02;
};

export const getSuccessRateText = (successRate: number) => {
  if (successRate >= 0.9) return "highest";
  if (successRate >= 0.75) return "high";
  if (successRate >= 0.5) return "medium";
  if (successRate >= 0.1) return "low";
  return "lowest";
};

// 任务难度奖励相关
export const baseChance = {
  [EquipmentRarity.Common]: 0.85,
  [EquipmentRarity.Rare]: 0.13,
  [EquipmentRarity.Epic]: 0.02,
};

export const MateEquipmentDecomposePowerCube: Record<EquipmentRarity, number> =
  {
    [EquipmentRarity.Common]: 0.1,
    [EquipmentRarity.Rare]: 0.5,
    [EquipmentRarity.Epic]: 2,
  };
export const getExtraChance = (difficultyLevel: DispatchDifficultyLevel) => {
  switch (difficultyLevel) {
    case DispatchDifficultyLevel.Medium:
      return {
        [EquipmentRarity.Rare]: 10,
        [EquipmentRarity.Epic]: 5,
      };
    case DispatchDifficultyLevel.Hard:
      return {
        [EquipmentRarity.Rare]: 25,
        [EquipmentRarity.Epic]: 15,
      };
    case DispatchDifficultyLevel.Nightmare:
      return {
        [EquipmentRarity.Rare]: 45,
        [EquipmentRarity.Epic]: 25,
      };
    case DispatchDifficultyLevel.Hell:
      return {
        [EquipmentRarity.Rare]: 85,
        [EquipmentRarity.Epic]: 65,
      };

    default:
      return {
        [EquipmentRarity.Rare]: 0,
        [EquipmentRarity.Epic]: 0,
      };
  }
};

export const getReturnPowerCube = (
  difficultyLevel: DispatchDifficultyLevel
) => {
  switch (difficultyLevel) {
    case DispatchDifficultyLevel.Easy:
    case DispatchDifficultyLevel.Medium:
    case DispatchDifficultyLevel.Hard:
      return "";
    case DispatchDifficultyLevel.Nightmare:
      return "10%~20%";
    case DispatchDifficultyLevel.Hell:
      return "25%~40%";
  }
};

// 赛季评分规则

export const baseScore = 20;

// 时间奖励
export const journalExtraScore = (count: number) => {
  switch (count) {
    case 1:
    case 2:
      return 0.8;
    case 3:
    case 4:
      return 1;
    case 5:
    case 6:
      return 1.2;
  }
  return 1;
};

// 邀请用户奖励
export const userExtraScore = 20;

// 前情奖励
export const previousMissionExtraScore = 5;

export const fixNumber = (number: number, rate = 1, fixCount = 5) => {
  return Number((number * rate).toFixed(fixCount));
};
